import * as React from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { dismissToast } from '../../store/notify';
import {
    ToastContactAlert,
    ToastItem,
    ToastMessageReceived,
    ToastStatus,
    ToastType,
} from '../../types/ToastItem';
import AlertErrorToast from './AlertErrorToast';
import AlertSuccessToast from './AlertSuccessToast';
import ContactAlertToast from './ContactAlertToast';
import MessageReceivedToast from './MessageReceivedToast';

export default React.memo(function ToastNotifications() {
    const dispatch = useAppDispatch();

    const toast = useAppSelector(state => state.notify?.displayToast);

    const handleDismiss = () => {
        //setOpen(false);
        dispatch(dismissToast());
    };

    return (
        <React.Fragment>
            <div>
                {toast?.type === ToastType.generic && toast?.status === ToastStatus.error && (
                    <AlertErrorToast config={toast as ToastItem} onDismissHandler={handleDismiss} />
                )}
                {toast?.type === ToastType.generic && toast?.status === ToastStatus.success && (
                    <AlertSuccessToast
                        config={toast as ToastItem}
                        onDismissHandler={handleDismiss}
                    />
                )}
                {toast?.type === ToastType.messageReceived && (
                    <MessageReceivedToast
                        config={toast as ToastMessageReceived}
                        onDismissHandler={handleDismiss}
                    />
                )}
                {toast?.type === ToastType.contactAlert && (
                    <ContactAlertToast
                        config={toast as ToastContactAlert}
                        onDismissHandler={handleDismiss}
                    />
                )}
            </div>
        </React.Fragment>
    );
});
